<template>
  <div class="main">
    <FormWrapper ref="updateAssetForm" :action="formAction" method="put">
      <div class="title-bar">
        <h1 class="mb-0">Edit Asset</h1>
        <a class="btn-back" :href="route('admin.assets.index')">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Back to List</span>
        </a>
      </div>
      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters pl-4">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" class="text-center" />
              </transition>
            </div>
            <div class="col-12 col-md-6 pr-md-4 asset-preview">
              <div v-if="isImage" class="image-preview">
                <div class="image-wrap">
                  <img :src="asset.url" :alt="asset.file" />
                </div>
              </div>
              <div v-else-if="isAudio" class="audio-preview">
                <audio :src="asset.url" controls preload="auto"></audio>
              </div>
              <div v-else-if="isVideo" class="video-preview">
                <video :src="asset.url" controls preload="auto"></video>
              </div>
              <div v-else-if="asset.extension == 'pdf'" class="pdf-preview">
                <object :data="asset.url" type="application/pdf" width="100%" height="100%"></object>
              </div>
              <div v-else class="document-preview">
                <iframe
                  :src="`https://docs.google.com/gview?url=${asset.url}&embedded=true`"
                  frameborder="0"
                ></iframe>
              </div>
              <div class="mt-3 bg-light p-3 asset-info">
                <p class="m-0">
                  <span class="label">Filename:</span>
                  <span class="value">{{ asset.file }}</span>
                  <br />
                  <template v-if="isImage">
                    <span class="label">Dimensions:</span>
                    <span class="value">{{ `${asset.width} x ${asset.height}` }}</span>
                    <br />
                  </template>
                  <span class="label">Size</span>
                  <span class="value">{{ asset.size }}</span>
                  <br />
                  <span class="label">Last Updated:</span>
                  <span class="value">{{ asset.updated_at | moment("MMMM Do, YYYY h:mma") }} UTC</span>
                </p>
              </div>
            </div>
            <div class="col-12 col-md-6 pl-md-4">
              <div class="row no-gutters">
                <div class="col-12 mb-3">
                  <Field
                    type="text"
                    name="name"
                    label="Name"
                    v-model="asset.name"
                    validate="required"
                    validate-as="Name"
                  />
                </div>
                <div class="col-12 mb-4">
                  <MultiAssignField
                    type="select"
                    name="categories"
                    label="Category"
                    :value="asset.category_ids"
                    :options="categories"
                  />
                </div>
                <div class="col-12">
                  <div class="label">Upload a New Version</div>
                  <Uploader :maxUpload="maxUpload" @uploaded="uploaded" />
                  <input type="hidden" name="file" :value="newFile" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="row no-gutters text-center">
              <div class="col-12 pb-2">
                <button type="submit" class="btn btn-success w-50">Save Changes</button>
              </div>
              <div class="col-12 py-2">
                <a :href="route('admin.assets.index')" class="btn btn-danger w-50">Cancel & Exit</a>
              </div>
              <div class="col-12 py-2">
                <a :href="route('admin.assets.download', { asset: asset.id })" target="_blank" class="btn btn-secondary w-50">Download</a>
              </div>
              <div class="col-12 font-size-sm text-center pt-4">
                <span>Last updated on {{ asset.updated_at | moment("MM/DD/YYYY") }}</span>
                <span>at {{ asset.updated_at | moment("h:mma") }}</span>
                <span v-if="asset.updatedBy">{{ " " + asset.updatedBy.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import Uploader from "./partials/Uploader";
export default {
  mixins: [DisplaysAlerts],
  components: { Uploader },
  props: {
    asset: { type: Object, required: true },
    categories: { type: Array, default: () => [] },
    maxUpload: { type: String, required: true },
  },
  data() {
    return {
      newFile: null,
    };
  },
  computed: {
    formAction() {
      return this.route("admin.assets.update", { asset: this.asset.id });
    },
    isDocument() {
      return this.asset.type == this.$root.constants.DOCUMENT_ASSET;
    },
    isImage() {
      return this.asset.type == this.$root.constants.IMAGE_ASSET;
    },
    isAudio() {
      return this.asset.type == this.$root.constants.AUDIO_ASSET;
    },
    isVideo() {
      return this.asset.type == this.$root.constants.VIDEO_ASSET;
    },
  },
  methods: {
    uploaded(file, response) {
      this.newFile = response.file;
      if (
        confirm(
          "Your new file has been successfully uploaded. Are you ready to save your changes?"
        )
      ) {
          this.$nextTick(() => {
            this.$refs.updateAssetForm.submit();
          })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.asset-preview {
  audio,
  video,
  object,
  iframe {
    height: auto;
    width: 100%;
  }
  object,
  iframe {
    min-height: 40rem;
  }
  .image-preview {
    position: relative;
    text-align: center;

    img {
      height: auto;
      max-width: 100%;
    }
  }
}
.asset-info {
  .label {
    display: inline-block;
    margin-right: 1rem;
    text-align: right;
    text-transform: uppercase;
    width: 33.333%;
  }
}
</style>